import type { BinaryFilter } from '@cubejs-client/core'
import { CubeFilterDimensions } from 'cube'
import {
  DRIFT_CHAT_CONVERSATION_ROUTING_DIMENSIONS,
  DRIFT_CHAT_CONVERSATIONS_RATINGS_DIMENSIONS,
} from 'cube/constants'

export type TeammatesColumnDrilldownFilter = {
  title: string
  filters: BinaryFilter[]
}

export const DRILLDOWN_KEY = 'routing-report-teammate-drilldown'

export const TeammatesColumnToDrilldownFilterMap: Record<
  string,
  TeammatesColumnDrilldownFilter
> = {
  count: {
    title: 'Routed chats',
    filters: [
      {
        member:
          DRIFT_CHAT_CONVERSATION_ROUTING_DIMENSIONS.HAS_TEAMMATE_ROUTED_IN,
        operator: 'equals',
        values: ['true'],
      },
    ],
  },
  countTeammateRoutedInToMissed: {
    title: 'Missed chats',
    filters: [
      {
        member:
          DRIFT_CHAT_CONVERSATION_ROUTING_DIMENSIONS.HAS_ROUTED_AND_EVERYONE_MISSED,
        operator: 'equals',
        values: ['true'],
      },
    ],
  },
  countConversationsWithUnresponsiveFallbackEvents: {
    title: 'Unresponsive fallback fired',
    filters: [
      {
        member: CubeFilterDimensions.CONVERSATION_HAS_UNRESPONSIVE_FALLBACK,
        operator: 'equals',
        values: ['true'],
      },
    ],
  },
  countTeammateRoutedInAndResponded: {
    title: 'Teammate responded',
    filters: [
      {
        member:
          DRIFT_CHAT_CONVERSATION_ROUTING_DIMENSIONS.HAS_TEAMMATE_RESPONDED,
        operator: 'equals',
        values: ['true'],
      },
    ],
  },
  countAverageRating: {
    title: 'Average rating',
    filters: [
      {
        member: DRIFT_CHAT_CONVERSATIONS_RATINGS_DIMENSIONS.CSAT_RATING,
        operator: 'equals',
        values: ['1', '2', '3', '4', '5'],
      },
    ],
  },
}

export const DrilldownUser = {
  USER: CubeFilterDimensions.USER_PARTICIPATED_USER_ID,
  ROUTED_IN_USER: CubeFilterDimensions.INITIAL_ROUTED_IN_USER,
}
